












	import Vue from 'vue';
    import _icons from '../../services/icons';

    export default Vue.extend({
        name: "ModListUserComp",
        props: ['user'],
        computed: {
            avatarLink: function(): string {
                if (this.user.discord) {
                    return this.user.discord.avatar;
                } else {
                    return _icons.miscIcon('raid');
                }
            },
            styleObject: function(): { color: string } {
                if (this.user.discord) {
                    return { color: this.user.discord.color };
                } else {
                    return { color: '#ff3333' };
                }

            }
        }
    })
